import 'vis-timeline/styles/vis-timeline-graph2d.min.css';
import moment from 'moment';
import {DataSet} from 'vis-data';
import {Timeline} from 'vis-timeline/standalone';
import {
  add_downtime_data,
  add_sequencer_data,
  add_sun_up_events_to_telescopes_all,
  add_tooltip,
  add_weather_events_to_telescopes_all,
  cache_timeline_width,
  click_thru_to_observation,
  click_thru_to_request,
  create_checkbox,
  create_legend_div,
  groups_data_sites,
  groups_data_telescopes_all,
  prepare_observation_data,
  set_timeline_options,
  sun_up_at_sites,
  utc_timestamp,
  weather_at_sites,
} from '../static/timeline.js';

window.vis = {DataSet, Timeline, moment};

function readConfig() {
  return JSON.parse(document.getElementById('timeline-config').textContent);
}

export function initializeTimeline(config = readConfig()) {
  const {sites, observations, weatherData, sunUpData, downtimeData, sequencerData} = config;
  const admin = config.admin === true;
  const loggedIn = config.loggedIn === true;

  for (const key of ['hide_not_attempted', 'auto_refresh']) {
    if (localStorage.getItem(key) === null) localStorage.setItem(key, 'true');
  }
  const autoRefresh = localStorage.getItem('auto_refresh') === 'true';
  const hideNotAttempted = localStorage.getItem('hide_not_attempted') === 'true';

  create_legend_div(loggedIn, admin);
  create_checkbox(autoRefresh, 'auto_refresh', 'Auto Refresh');
  if (admin) create_checkbox(hideNotAttempted, 'hide_not_attempted', 'Hide Not Attempted Observations');

  const startDate = new Date(utc_timestamp());
  startDate.setUTCDate(startDate.getUTCDate() - config.daysIntoPast);
  const endDate = new Date(utc_timestamp());
  endDate.setUTCDate(endDate.getUTCDate() + config.daysIntoFuture);
  const timeData = {start: startDate, end: endDate};

  const groups = new DataSet();
  groups.add(groups_data_sites(sites));
  groups.add(groups_data_telescopes_all(sites, admin));

  const items = new DataSet();
  const telescopeWeather = add_weather_events_to_telescopes_all(sites, weatherData, timeData);
  items.add(weather_at_sites(weatherData, timeData));
  items.add(telescopeWeather);
  items.add(prepare_observation_data(observations, admin, config.hidePastPending, hideNotAttempted, telescopeWeather));
  items.add(sun_up_at_sites(sunUpData));
  items.add(add_sun_up_events_to_telescopes_all(sites, sunUpData));
  items.add(add_downtime_data(downtimeData, timeData));
  items.add(add_sequencer_data(sequencerData, timeData));

  const timeline = new Timeline(
    document.getElementById('visualization'),
    items,
    groups,
    set_timeline_options(config.daysIntoPast, config.daysIntoFuture),
  );
  window.timeline = timeline;

  if (autoRefresh && !document.body.dataset.testMode) {
    window.setTimeout(() => {
      cache_timeline_width();
      location.reload();
    }, 300000);
  }

  timeline.on('click', properties => {
    if (properties.item == null && properties.what !== 'group-label') return;
    if (properties.event.ctrlKey || properties.event.altKey) {
      click_thru_to_observation(admin, properties, items, config.observationPortalUrl);
    } else if (properties.item != null) {
      click_thru_to_request(admin, properties, items, config.observationPortalUrl);
    }
  });
  timeline.on('mouseOver', properties => add_tooltip(
    properties, weatherData, downtimeData, sequencerData,
  ));
  document.documentElement.dataset.timelineReady = 'true';
  return {timeline, groups, items};
}

document.addEventListener('DOMContentLoaded', () => initializeTimeline());
